import React from 'react'
import Geocoder from './geocoder'
import * as personalizerStyles from '../../styles/project-modules/personalize/personalizer.module.less'
import { point } from '@turf/helpers'
import pointInPolygon from '@turf/boolean-point-in-polygon'
import Result from './Result'
import useSWR from 'swr'
import { getData } from '../sfc/component-helpers/requesthelpers'
import storySettings from '../../data/story_settings.sheet.json'

function Personalizer({ MARKET_KEY, yourLegislators, setYourLegislators, billPage=false }) {
  const {Geocoder_Placeholder} = storySettings[0];

  const MAP_DATA = {
    sldu: require(`../../data/sfc/maps/${MARKET_KEY}-sldu.json`),
    sldl: require(`../../data/sfc/maps/${MARKET_KEY}-sldl.json`),
  }
  const state_market_key = MARKET_KEY === 'Houston' || MARKET_KEY === 'SanAntonio' || MARKET_KEY === 'Texcom' ? 'TX' : MARKET_KEY
  const { data: responseData, error } = useSWR(
  `https://sfc-project-files.s3.amazonaws.com/legistracker/google_contacts/legis-contacts-${state_market_key}.json`,
    getData,
    {
      onSuccess: (data) => console.log(data),
      onError: (err) => console.log(err),
    }
  )
  function handleGeocode(coords) {
    const pt = point([coords.x, coords.y])

    const chambers = Object.keys(MAP_DATA)
    // console.log(chambers)

    let result = []

    chambers.forEach((chamber) => {
      let map = MAP_DATA[chamber]
      for (const feature of map.features) {
        let properties = feature.properties
        //check if our point falls in this district
        let isOurDistrict = pointInPolygon(pt, feature.geometry)

        if (isOurDistrict) {
          //then grab contact info
          let contactInfo

          if (responseData) {
            // console.log(responseData[properties.ocd_id])
            contactInfo = responseData[properties.ocd_id]
            console.log(contactInfo)
            // console.log('Contact info:', contactInfo, 'checking: ', properties.ocd_id, ' Response Data: ', responseData)
          } else {
            contactInfo = null
          }
          // console.log('pushing to result: ', contactInfo)
          result.push(contactInfo)
          break
        }
      }
    })
    // console.log(result)
    setYourLegislators(result)
  }
  return (
    <div className={`${!billPage ? personalizerStyles.container : personalizerStyles.containerBillPage}`} id="personalizer">
      {!billPage && <h3 className={personalizerStyles.title}>Enter your address to follow your legislators</h3>}
      {/* <p className={personalizerStyles.dek}>
        Enter your address to highlight your legislators:
      </p> */}
      <Geocoder resultFunc={handleGeocode} placeholder={Geocoder_Placeholder ? Geocoder_Placeholder : '901 Mission Street, San Francisco'}/>
      <div>
        <p>
          We'll show how your legislators voted and how you can contact them. We won't save or share your address.
        </p>
      </div>
      {yourLegislators  && (
        <Result yourLegislators={yourLegislators} MARKET_KEY={MARKET_KEY} />
      )}
      <em><p className={personalizerStyles.dataSource}>Source: Google Civic Information API</p></em>
    </div> 
  )
}

export default Personalizer
